import {getRequest} from '@/domain/repository/apiRequests';
import {Credentials, LoginError} from '@/domain/commonTypes';
import {API_URL} from '@/config';
import {User} from '@/domain/entities/User';
import {post} from '@/domain/repository/jsonHttp';

export type LoginBody = {
  email: string,
  password: string
}

export type RefreshLogin = {
  refresh: string
}

const CREATE_TOKEN_URL = 'token/create';
const REFRESH_TOKEN_URL = 'token/refresh/';
const USERS = 'auth/users/';
const ME_URL = 'auth/users/me/';

const authRepository = {
  create: (body: LoginBody): Promise<Credentials | LoginError> => {
    return post<LoginBody, Credentials>({
      path: CREATE_TOKEN_URL,
      baseUrl: API_URL,
      body
    });
  },
  refresh: (body: RefreshLogin): Promise<Credentials> => {
    return post<Credentials, RefreshLogin>({
      path: REFRESH_TOKEN_URL,
      baseUrl: API_URL,
      body,
    });
  },
  users: (): Promise<Array<User>> => {
    return getRequest<Array<User>>({
      path: USERS
    });
  },
  me: (): Promise<User> => {
    return getRequest<User>({
      path: ME_URL
    });
  }
};

export default authRepository;